export default __webpack_public_path__ + "static/media/2-4.c55c8a39.png";